var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAzureLicensesLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.667,
    height: 11.667,
    x: 28.167,
    y: 0.458,
    fill: "#EEF0F3",
    rx: 1.458
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.667,
    height: 11.667,
    x: 55.875,
    y: 55.875,
    fill: "#EEF0F3",
    rx: 1.458
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.667,
    height: 11.667,
    x: 0.458,
    y: 55.875,
    rx: 1.458
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.84 12.125L58.547 55.875M9.453 55.875L33.16 12.125M55.875 61.708L12.125 61.708"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureLicensesLarge);
export default __webpack_public_path__ + "static/media/azure-licenses-large.e402ce024d04ace995c5d5c7cbee9740.svg";
export { ForwardRef as ReactComponent };